import { Component, OnInit, Input } from '@angular/core';
import { ElementLog } from '../../../../utilities/stores/element-log/element-log.interface';
import { UserService } from '../../../user/user.service';

/**
 * Log item.
 *
 * An individual item in the element log.
 */
@Component({
  selector: 'sg2-element-logs-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.less']
})
export class ElementLogsItemComponent implements OnInit {

  /** Filter items. @deprecated */
  @Input() filter?: 'change' | 'comment';

  /** Current log item. */
  @Input() log: ElementLog;

  /** The user who made a change to the element. */
  public user: User;

  constructor(
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this._filterLog();
    this._setUser();
  }

  /**
   * Filter log item.
   */
  private _filterLog(): void {
    if (this.filter) {
      this.log = this.log && this.log.type === this.filter.toUpperCase()
        ? this.log
        : null;
    }
  }

  /**
   * Set user object.
   *
   * Fix for: log *changes* have a full user object in the userId property, while
   * *comments* have the user id as a string.
   *
   * @todo This is already fixed in the UserStore, but not in legacy code. Do not
   *  remove until after full migration, for backwards compatibility.
   */
  private _setUser(): void {
    if (!this.log) {
      return;
    } else if (typeof this.log.userId === 'object') {
      this.user = this.log.userId;
    } else {
      this.userService.user$.subscribe(users => {
        this.user = users.filter(user => user._id === this.log.userId)[0];
      });
    }
  }
}
